import { render, staticRenderFns } from "./MoldPrepare.vue?vue&type=template&id=c86e4490&"
import script from "./MoldPrepare.vue?vue&type=script&lang=js&"
export * from "./MoldPrepare.vue?vue&type=script&lang=js&"
import style0 from "./MoldPrepare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports